import React, { useContext, useEffect, useState } from 'react'
import { apiPut, apiGet } from '../../../utils/apiFetch'
import apiPath from '../../../utils/apiPath'
import useToastContext from 'hooks/useToastContext'
import { AiFillEye } from 'react-icons/ai'
import { useTranslation } from 'react-i18next'
import {
  BsArrowUpShort,
  BsHandThumbsDown,
  BsHandThumbsUp
} from 'react-icons/bs'
import AuthContext from 'context/AuthContext'
import { isEmpty, startCase } from 'lodash'
import helper from '../../../utils/helpers'
import Pagination from 'pages/Pagination'
import CompanyApprovalView from './CompanyApprovalView'
import OImage from 'components/reusable/OImage'
import homeImage from '../../../assets/images/home.png'
import classNames from 'classnames'

const CompanyApproval = ({ companyId, manager }) => {
  const [viewShow, setViewShow] = useState(false)
  const [agent, setAgent] = useState([])
  const [page, setPage] = useState(1)
  const [pageSize] = useState(10)
  const [item, setItem] = useState('')
  const [paginationObj, setPaginationObj] = useState({
    page: 1,
    pageCount: 1,
    pageRangeDisplayed: 10
  })
  const handleUserView = newItem => {
    setItem(newItem)
    setViewShow(true)
  }

  const [sort, setSort] = useState({
    sortKey: 'createdAt',
    sortType: 'desc'
  })
  const { t } = useTranslation()
  const { user } = useContext(AuthContext)
  const notification = useToastContext()

  const handelStatusChange = async newItem => {
    try {
      const payload = {
        isApprovedStatus: newItem?.status
      }
      const path = `${apiPath.approvalCompanyStatusChange}/${newItem?._id}`
      const result = await apiPut(path, payload)
      if (result?.status === 200) {
        notification.success(result.data.message)
        getCompaniesApproval()
      }
      // }
    } catch (error) {
      console.error('error in get all sub admin list==>>>>', error.message)
    }
  }

  const getCompaniesApproval = async () => {
    try {
      const payload = {
        page,
        pageSize: pageSize,
        sortKey: sort.sortKey,
        sortType: sort.sortType,
        companyId
      }

      const path = apiPath.getApprovalCompanies
      const result = await apiGet(path, payload)
      const response = result?.data?.results
      const resultStatus = result?.data?.success
      setAgent(response?.docs)
      setPaginationObj({
        ...paginationObj,
        page: resultStatus ? response.page : null,
        pageCount: resultStatus ? response.totalPages : null,
        perPageItem: resultStatus ? response?.docs.length : null,
        totalItems: resultStatus ? response.totalDocs : null
      })
      // }
    } catch (error) {
      console.error('error in get all users list==>>>>', error.message)
    }
  }

  const handlePageClick = event => {
    const newPage = event.selected + 1
    setPage(newPage)
  }

  useEffect(() => {
    getCompaniesApproval()
  }, [page, sort])
  return (
    <>
      <div className='p-3'>
        <div className='overflow-x-auto relative 
 border'>
          <table className='w-full text-xs text-left text-[#A5A5A5] dark:text-gray-400 '>
            <thead className='text-xs text-gray-900 border border-[#E1E6EE] bg-[#E1E6EE] dark:bg-gray-700 dark:text-gray-400'>
              <tr>
                <th scope='col' className='py-3 px-6 text-center'>
                  #
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'name' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'name',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'name',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('COMPANY_NAME')} </span>
                    <span>
                      {sort.sortKey === 'name' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'name' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>

                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'email' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'email',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'email',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('COMPANY_LOGO')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    setSort(prevSort => ({
                      sortKey: 'email',
                      sortType: prevSort.sortType === 'asc' ? 'desc' : 'asc'
                    }))
                  }}
                >
                  <div className='flex'>
                    <span>{t('O_COMPANY_EMAIL_ADDRESS')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th scope='col' className='py-3 px-6'>
                  <div className='flex'>
                    <span>{t('O_COUNTRY_CODE')} </span>
                  </div>
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'email' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'email',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'email',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('O_MOBILE_NUMBER')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    if (sort.sortKey === 'email' && sort.sortType === 'asc') {
                      setSort({
                        sortKey: 'email',
                        sortType: 'desc'
                      })
                    } else {
                      setSort({
                        sortKey: 'email',
                        sortType: 'asc'
                      })
                    }
                  }}
                >
                  <div className='flex'>
                    <span>{t('HEAD_OFFICE')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>
                <th
                  scope='col'
                  className='py-3 px-6 cursor-pointer'
                  onClick={() => {
                    setSort(prevSort => ({
                      sortKey: 'email',
                      sortType: prevSort.sortType === 'asc' ? 'desc' : 'asc'
                    }))
                  }}
                >
                  <div className='flex'>
                    <span>{t('AUTHORIZED_PERSON_NAME')} </span>
                    <span>
                      {sort.sortKey === 'email' && sort.sortType === 'asc' && (
                        <BsArrowUpShort className='w-4 h-4' />
                      )}
                      {sort.sortKey === 'email' && sort.sortType === 'desc' && (
                        <BsArrowUpShort className='w-4 h-4 rotate-180' />
                      )}
                    </span>
                  </div>
                </th>

                <th scope='col' className='py-3 px-6 '>
                  {t('ORN')}
                </th>
                {/* <th scope='col' className='py-3 px-6 '>
                  {t('O_STATUS')}
                </th> */}
                {(manager?.add || user?.role === 'admin') && (
                  <th
                    scope='col'
                    className='py-3 px-6 cursor-pointer '
                    onClick={() => {
                      if (
                        sort.sortKey === 'updatedAt' &&
                        sort.sortType === 'asc'
                      ) {
                        setSort({
                          sortKey: 'updatedAt',
                          sortType: 'desc'
                        })
                      } else {
                        setSort({
                          sortKey: 'updatedAt',
                          sortType: 'asc'
                        })
                      }
                    }}
                  >
                    <div className='flex '>
                      {t('O_STATUS')}
                      {sort.sortKey === 'updatedAt' &&
                        sort.sortType === 'asc' && (
                          <BsArrowUpShort className='w-4 h-4' />
                        )}
                      {sort.sortKey === 'updatedAt' &&
                        sort.sortType === 'desc' && (
                          <BsArrowUpShort className='w-4 h-4 rotate-180' />
                        )}
                    </div>
                  </th>
                )}

                <th scope='col' className='py-3 px-6 text-center'>
                  {t('O_ACTION')}
                </th>
              </tr>
            </thead>
            <tbody>
              {agent?.map((item, i) => (
                <tr
                  key={i}
                  className='bg-white border-b dark:bg-gray-800 dark:border-gray-700'
                >
                  <th
                    scope='row'
                    className='py-2 px-2 text-center border-r font-medium text-gray-900  dark:text-white'
                  >
                    {i + 1 + 10 * (paginationObj?.page - 1)}
                  </th>
                  <td className='py-2 px-2 border-r'>{item?.name}</td>
                  <td className='py-2 px-2 border-r text-center'>
                    <figure className='inline-block overflow-hidden rounded-full border-2 mb-0'>
                      <OImage
                        src={item?.logo}
                        fallbackUrl={homeImage}
                        className='w-10 h-10'
                      />
                    </figure>
                  </td>
                  <td className='py-2 px-2 border-r'>{item?.email} </td>
                  <td className='py-2 px-2 border-r'>{item?.countryCode}</td>
                  <td className='py-2 px-2 border-r'>{item?.mobile}</td>
                  <td className='py-2 px-2 border-r'>{item?.headOffice}</td>
                  <td className='py-2 px-2 border-r '>
                    {startCase(item?.authorizationPersonName) || 'N/A'}
                  </td>
                  <td className='py-2 px-2 border-r '>{item?.orn}</td>
                  {/* <td className='py-2 px-2 border-r '>
                      {startCase(item?.isApprovedStatus)}
                    </td> */}
                  {(manager?.add || user?.role === 'admin') && (
                    <>
                      <td className='py-2 px-2 border-r text-center'>
                        {item?.isApprovedStatus === 'pending' && (
                          <>
                            <button
                              title={t('O_ACCEPT')}
                              type='button'
                              onClick={() =>
                                helper.alertFunction(
                                  `Are you sure want to approve ${item?.name}?`,
                                  { _id: item?._id, status: 'accepted' },
                                  handelStatusChange
                                )
                              }
                              className='animate-bounce text-lg border border-transparent text-green-600 hover:text-green-900'
                            >
                              <BsHandThumbsUp />
                            </button>
                            <button
                              title={t('O_REJECT')}
                              type='button'
                              onClick={() =>
                                helper.alertFunction(
                                  `Are you sure want to reject ${item?.name}?`,
                                  { _id: item?._id, status: 'rejected' },
                                  handelStatusChange
                                )
                              }
                              className='animate-bounce text-lg border border-transparent text-red-600 hover:text-red-900'
                            >
                              <BsHandThumbsDown />
                            </button>
                          </>
                        )}
                        {item?.isApprovedStatus !== 'pending' && (
                          <span
                            className={classNames('', {
                              'text-green-600':
                                item?.isApprovedStatus === 'accepted',
                              'text-red-600':
                                item?.isApprovedStatus === 'rejected'
                            })}
                          >
                            {startCase(item?.isApprovedStatus)}
                          </span>
                        )}
                      </td>
                    </>
                  )}
                  <td className='py-2 px-2 border-l'>
                    <div className=''>
                      <ul className='flex justify-center'>
                        <li
                          className='px-2 py-2 hover:bg-white hover:text-LightBlue cursor-pointer'
                          onClick={() => handleUserView(item)}
                        >
                          <AiFillEye className=' w-5 h-5 text-slate-600' />{' '}
                        </li>
                      </ul>
                    </div>
                  </td>
                </tr>
              ))}
              {isEmpty(agent) && (
                <tr className='bg-white border-b w-full text-center dark:bg-gray-800 dark:border-gray-700'>
                  <td className='py-2 px-2' colSpan={12}>
                    {t('O_NO_RECORD_FOUND')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {paginationObj?.totalItems !== 0 && (
        <Pagination
          handlePageClick={handlePageClick}
          options={paginationObj}
          page={page}
        />
      )}

      {viewShow && (
        <CompanyApprovalView setViewShow={setViewShow} item={item} />
      )}
    </>
  )
}

export default CompanyApproval
